import { call, getContext, put, takeLatest } from "redux-saga/effects";

import {
  getScheduledStreamsSuccess,
  getScheduledStreamsFailure,
} from "./actions";
import { getScheduledStreamsActionTypes } from "./actionTypes";
import { CONTEXT } from "@const/redux";

const getScheduledStreamsAsync = ({ LivestreamsService, params }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.getScheduledStreams(params);
};

function* getScheduledStreams({ payload }) {
  try {
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);

    const { data, pagination } = yield call(getScheduledStreamsAsync, {
      LivestreamsService,
      params: payload,
    });

    const { totalCount, nextOffset } = pagination;

    yield put(
      getScheduledStreamsSuccess({
        livestreams: data,
        totalCount,
        nextOffset,
      }),
    );
  } catch ({ error }) {
    yield put(getScheduledStreamsFailure(error));
  }
}

export function* watchGetScheduledStreams() {
  yield takeLatest(getScheduledStreamsActionTypes.request, getScheduledStreams);
}
